import { Trophy } from "lucide-react";

export function LeaderboardsHeader() {
    return (
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-outline-variant/30">
            <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-general-yellow rounded-md flex items-center justify-center">
                    <Trophy className="text-white w-5 h-5" />
                </div>
                <div className="flex flex-col">
                    <h1 className="text-2xl font-headline font-bold text-on-surface">Historic Leaderboards</h1>
                </div>
            </div>
        </div>
    );
}
